import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { ITrainingProgram } from '../models/trainingprogram';

@Injectable()
export class TrainingProgramService {

  private _url = './api/trainingprogram/';

  constructor(private _http: HttpClient) { }

  getTrainingPrograms(): Observable<Array<ITrainingProgram>> {

    return this._http.get<Array<ITrainingProgram>>(this._url + 'programs')
      .pipe(
        map(result => result),
        catchError(this.handleError)
      );
  }

  updateTrainingProgram(programId: number, activityId: number, completed: boolean) {
    return this._http.post(this._url + "update", { programId: programId, activityId: activityId, completed: completed })
      .pipe(
        map((resp: Response) => resp),
        catchError(this.handleError)
      );
  }

  private handleError(err: HttpErrorResponse) {
    console.log(err.message);
    return throwError(err.message);
/*    return Observable.throw(err.message);*/
  }
}
